import { useState, useEffect, useMemo } from 'react';
import { calculateKpiData } from '../utils';
import { KpiType } from '../enums';
import { getKpiPhotoRequest, getKpiRequestsData } from '../services/kpi.service';
import { KpiData } from '../interfaces/kpi';
import { PhotoRequestStatus } from '@homesusa/core';

export const useKpiData = () => {
  const [kpiData, setKpiData] = useState<KpiData>({
    kpiDataRequest: [],
    totalPhotoRequest: 0
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const listingRequestsData = await getKpiRequestsData();
        const photoRequestsData = await getKpiPhotoRequest({
          isOnlyCount: true,
          Status: PhotoRequestStatus.Pending
        });
        setKpiData({
          kpiDataRequest: listingRequestsData.data,
          totalPhotoRequest: photoRequestsData.total
        });
      } catch (error) {}
    };

    fetchData();
    const intervalId = setInterval(fetchData, 60000);

    return () => clearInterval(intervalId);
  }, []);

  const { residentialTotal, lotTotal, residentialDetails, lotDetails, totalPhotoRequest } =
    useMemo(() => {
      const residential = calculateKpiData(kpiData.kpiDataRequest, KpiType.Residential);
      const lot = calculateKpiData(kpiData.kpiDataRequest, KpiType.Lot);

      return {
        residentialTotal: residential.total,
        lotTotal: lot.total,
        residentialDetails: residential.details,
        lotDetails: lot.details,
        totalPhotoRequest: kpiData.totalPhotoRequest
      };
    }, [kpiData]);

  return {
    residentialTotal,
    lotTotal,
    residentialDetails,
    lotDetails,
    totalPhotoRequest
  };
};
